import { useMemo } from "react";
import { useGetDictionaries } from "@synthesis/shared-services/internal/dictionaries/hooks";

import type { CreateApplicationSelectOption } from "../../pages/create-application-page/create-application-dictionaries.lib";

const toOption = (item: { code?: string | null; displayName?: string | null }): CreateApplicationSelectOption | null => {
  const value = item.code?.trim();
  const label = item.displayName?.trim();

  if (!value || !label) {
    return null;
  }

  return { value, label };
};

/**
 * Справочник (базовый): дороги, те же, что используются при создании заявки
 * (internal dictionaries API). Возвращает опции { value: code, label: displayName }.
 */
export const useRailways = () => {
  const query = useGetDictionaries({ query: { enabled: true } });

  const railways = useMemo<CreateApplicationSelectOption[]>(
    () => (query.data?.railways ?? []).map(toOption).filter((option): option is CreateApplicationSelectOption => option !== null),
    [query.data],
  );

  return {
    railways,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
